var _defineProperty = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/es.array.reduce.js");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.theme = factory());
})(this, function () {
  'use strict'; // DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-tokens'
  // ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN

  var colors = {},
      fontFamilies = {},
      lineHeights = {},
      fontWeights = {},
      fontSizes = {},
      spacing = {},
      sizing = {},
      borderRadius = {},
      boxShadow = {},
      borderWidth = {},
      motion = {},
      opacity = {};
  colors.black10 = '#fafafa';
  colors.black20 = '#e7eeec';
  colors.black30 = '#b8c4c2';
  colors.black40 = '#9fa1a2';
  colors.black50 = '#5d6c74';
  colors.black70 = '#3d4f58';
  colors.black80 = '#21313c';
  colors.black90 = '#061621';
  colors.black00 = '#ffffff';
  colors.blue10 = '#e1f2f6';
  colors.blue20 = '#cfe4f2';
  colors.blue40 = '#7acfdd';
  colors.blue50 = '#2f9fc5';
  colors.blue70 = '#007cad';
  colors.blue80 = '#1a567e';
  colors.blue90 = '#0d324f';
  colors.purple10 = '#f1f0fc';
  colors.purple20 = '#d5d4f9';
  colors.purple40 = '#9795f9';
  colors.purple50 = '#6e60f9';
  colors.purple70 = '#4f4fbf';
  colors.purple80 = '#36367f';
  colors.purple90 = '#273359';
  colors.green10 = '#e7f2eb';
  colors.green20 = '#b9eacd';
  colors.green30 = '#83dba7';
  colors.green40 = '#0ad05b';
  colors.green50 = '#13AA52';
  colors.green70 = '#09804c';
  colors.green80 = '#116149';
  colors.green90 = '#0b3b35';
  colors.red10 = '#ffe1ea';
  colors.red20 = '#f4bdca';
  colors.red40 = '#ef8f9d';
  colors.red50 = '#ea5c76';
  colors.red70 = '#d83a6c';
  colors.red80 = '#a53060';
  colors.red90 = '#70234a';
  colors.orange10 = '#fcebe2';
  colors.orange20 = '#f9d3c5';
  colors.orange40 = '#f7a765';
  colors.orange50 = '#f97216';
  colors.orange70 = '#cf4a22';
  colors.orange80 = '#8f221b';
  colors.orange90 = '#570b08';
  colors.yellow10 = '#fef7e3';
  colors.yellow20 = '#fef2c8';
  colors.yellow40 = '#ffeb99';
  colors.yellow50 = '#ffdd49';
  colors.yellow70 = '#a49437';
  colors.yellow80 = '#86681d';
  colors.yellow90 = '#543e07';
  colors.magenta10 = '#f9edf3';
  colors.magenta20 = '#f4bde5';
  colors.magenta40 = '#dd85bb';
  colors.magenta50 = '#d4459c';
  colors.magenta70 = '#b2478e';
  colors.magenta80 = '#7f336a';
  colors.magenta90 = '#592446';
  colors.text = {
    default: colors.black80,
    secondary: colors.black50,
    inverse: colors.black00,
    inverseSecondary: colors.black30,
    error: colors.red70,
    errorInverse: colors.red50,
    neutral: colors.black50,
    selected: colors.green70,
    inverseSelected: colors.green40,
    mark: colors.green70,
    inverseMark: colors.green40
  };
  colors.border = {
    default: colors.black30,
    inverse: colors.black50,
    inverseDarker: colors.black70
  };
  colors.icon = {
    error: colors.red70,
    errorInverse: colors.red50,
    warning: colors.yellow50,
    branded: {
      primary: colors.green50,
      secondary: colors.green80,
      tertiary: colors.purple50,
      inversePrimary: colors.green40,
      inverseSecondary: colors.black00
    },
    system: {
      default: colors.black70,
      defaultNeutral: colors.black50,
      inverse: colors.black00,
      inverseNeutral: colors.black30,
      success: colors.green50,
      successInverse: colors.green40
    }
  };
  colors.background = {
    body: colors.black00,
    container: colors.black10,
    containerLighter: colors.black00,
    containerInverse: colors.black80,
    containerInverseDarker: colors.black90,
    selected: colors.green50,
    selectedLighter: colors.green10,
    panel: colors.black00,
    selectedInverseLighter: colors.black70
  };
  colors.button = {
    primary: {
      bg: colors.green50,
      bgLighter: colors.green40,
      bgDarker: colors.green70,
      bgDisabled: colors.black30,
      text: colors.black00,
      textDisabled: colors.black50
    },
    secondary: {
      bg: colors.black00,
      bgDarker: colors.black10,
      bgDisabled: colors.black30,
      text: colors.green50,
      border: colors.green50
    },
    inversePrimary: {
      bg: colors.green40,
      bgDarker: colors.black10,
      bgDisabled: colors.black70,
      text: colors.black90,
      textDisabled: colors.black30,
      bgLighter: colors.green30
    },
    inverseSecondary: {
      bg: colors.black80,
      bgLighter: colors.black70,
      bgDisabled: colors.black70,
      text: colors.green40,
      textDisabled: colors.black30,
      border: colors.green40
    },
    faux: {
      text: colors.green50,
      textActive: colors.green80
    },
    inversefaux: {
      text: colors.green40,
      textActive: colors.green30
    }
  };
  colors.input = {
    default: {
      bg: colors.black00,
      bgDisabled: colors.black10,
      border: colors.black30,
      borderError: colors.red70,
      text: colors.text.default,
      textSecondary: colors.text.secondary,
      textError: colors.text.error
    },
    inverse: {
      bg: colors.black80,
      bgDisabled: colors.black70,
      border: colors.black50,
      borderError: colors.red50,
      text: colors.text.inverse,
      textSecondary: colors.text.inverseSecondary,
      textError: colors.text.errorInverse
    }
  };
  colors.link = {
    cta: {
      default: {
        text: colors.black80,
        icon: colors.green50,
        textDisabled: colors.black50,
        iconDisabled: colors.black50
      },
      inverse: {
        text: colors.black00,
        icon: colors.green40
      }
    },
    navigation: {
      text: colors.black80,
      textSelected: colors.green50
    },
    footer: {
      text: colors.black00,
      textSelected: colors.green40
    },
    inline: {
      default: {
        text: colors.green50,
        underline: colors.green50
      },
      inverse: {
        text: colors.green40,
        underline: colors.black00
      }
    }
  };
  colors.pill = {
    identifier: {
      primary: {
        text: colors.black90,
        bgInformational: colors.blue20,
        bgCritical: colors.red10
      },
      secondary: {
        textInformational: colors.black00,
        bgInformational: colors.blue70,
        bgCritical: colors.red70
      },
      inverse: {
        borderInformational: colors.blue20,
        inverseText: colors.blue20
      }
    },
    badge: {
      default: {
        bg: colors.green40,
        text: colors.green90
      },
      inverse: {
        bg: colors.green40,
        text: colors.black90
      }
    }
  };
  colors.tag = {
    border: colors.blue50,
    text: colors.blue50,
    bg: colors.blue20,
    inverseBorder: colors.blue20,
    inverseText: colors.blue20,
    inverseBG: colors.blue90
  };
  colors.panels = {
    default: {
      bg: colors.black10,
      bgLighter: colors.black00,
      border: colors.black30
    },
    inverse: {
      bg: colors.black80,
      bgDarker: colors.black90,
      border: colors.black50
    },
    navigation: {
      bg: colors.black00,
      border: colors.black30
    },
    card: {
      bg: colors.black00,
      bgDarker: colors.black10,
      border: colors.black30
    },
    modal: {
      bg: colors.black00,
      bgDarker: colors.black10,
      border: colors.black30
    },
    notification: {
      bgSuccess: colors.green10,
      borderSuccess: colors.green20,
      bgAlert: colors.yellow10,
      borderAlert: colors.yellow40,
      bgNote: colors.blue10,
      borderNote: colors.blue20,
      bgDanger: colors.orange10,
      borderDanger: colors.orange20,
      innerSuccess: colors.green80,
      innerNote: colors.blue80,
      innerDanger: colors.orange80,
      innerAlert: colors.yellow90
    },
    tooltip: {
      bgInverse: colors.black80,
      borderInverse: colors.black50,
      bg: colors.black00,
      border: colors.black30
    },
    popover: {
      bg: colors.black00,
      border: colors.black30,
      bgInverse: colors.black80,
      borderInverse: colors.black50
    },
    select: {
      bg: colors.black00,
      bgInverse: colors.black80,
      borderInverse: colors.black50,
      border: colors.black30
    }
  };
  colors.tabs = {
    tertiary: {
      borderHover: colors.blue70,
      bgActive: colors.blue70,
      bg: colors.black20,
      bgInverse: colors.black70
    }
  };
  colors.code = {
    bg: colors.black80,
    bgLines: colors.black90
  };
  colors.card = {
    default: {
      bg: colors.black00,
      border: colors.black30,
      textSub: colors.green70,
      borderDarker: colors.green90
    },
    inverse: {
      bg: colors.black80,
      border: colors.black70,
      textSub: colors.green40,
      borderLighter: colors.green40
    }
  };
  fontFamilies.menlo = 'Menlo';
  fontFamilies['akzidenz-grotesk-std'] = 'Akzidenz-Grotesk Std';
  fontFamilies['euclid-circular-a'] = 'Euclid Circular A';
  fontFamilies['source-code-pro'] = 'Source Code Pro';
  fontFamilies['mongodb-value-serif'] = 'MongoDB Value Serif';
  fontFamilies.heading = fontFamilies['akzidenz-grotesk-std'];
  fontFamilies.body = fontFamilies['akzidenz-grotesk-std'];
  fontFamilies.mono = fontFamilies['source-code-pro'];
  lineHeights.inc00 = 16;
  lineHeights.inc10 = 18;
  lineHeights.inc20 = 24;
  lineHeights.inc30 = 32;
  lineHeights.inc40 = 40;
  lineHeights.inc50 = 48;
  lineHeights.inc60 = 56;
  lineHeights.inc70 = 64;
  lineHeights.inc80 = 72;
  lineHeights.inc90 = 112;
  lineHeights.headingXXL = lineHeights.inc90;
  lineHeights.headingXL = lineHeights.inc80;
  lineHeights.headingL = lineHeights.inc70;
  lineHeights.headingM = lineHeights.inc60;
  lineHeights.headingS = lineHeights.inc50;
  lineHeights.headingXS = lineHeights.inc30;
  lineHeights.headingXXLResponsive = lineHeights.inc60;
  lineHeights.headingXLResponsive = lineHeights.inc50;
  lineHeights.headingLResponsive = lineHeights.inc40;
  lineHeights.headingMResponsive = lineHeights.inc30;
  lineHeights.headingSResponsive = lineHeights.inc30;
  lineHeights.headingXSResponsive = lineHeights.inc20;
  lineHeights.bodyL = lineHeights.inc30;
  lineHeights.bodyM = lineHeights.inc30;
  lineHeights.bodyS = lineHeights.inc20;
  lineHeights.bodyXS = lineHeights.inc00;
  lineHeights.bodyLResponsive = lineHeights.inc30;
  lineHeights.bodyMResponsive = lineHeights.inc30;
  lineHeights.bodySResponsive = lineHeights.inc20;
  lineHeights.bodyXSResponsive = lineHeights.inc00;
  lineHeights.monoL = lineHeights.inc30;
  lineHeights.monoM = lineHeights.inc20;
  lineHeights.monoS = lineHeights.inc00;
  lineHeights.monoLResponsive = lineHeights.inc30;
  lineHeights.monoMResponsive = lineHeights.inc20;
  lineHeights.monoSResponsive = lineHeights.inc00;
  fontWeights.medium = 'Medium';
  fontWeights.light = 'Light';
  fontWeights.regular = 'Regular';
  fontWeights.bold = 'Bold';
  fontWeights.semibold = 'Semibold';
  fontSizes.inc00 = 12;
  fontSizes.inc10 = 14;
  fontSizes.inc20 = 16;
  fontSizes.inc30 = 18;
  fontSizes.inc40 = 20;
  fontSizes.inc50 = 24;
  fontSizes.inc60 = 28;
  fontSizes.inc70 = 32;
  fontSizes.inc80 = 36;
  fontSizes.inc90 = 40;
  fontSizes.inc100 = 44;
  fontSizes.inc110 = 48;
  fontSizes.inc120 = 56;
  fontSizes.inc130 = 64;
  fontSizes.inc140 = 96;
  fontSizes.headingXXL = fontSizes.inc140;
  fontSizes.headingXL = fontSizes.inc130;
  fontSizes.headingL = fontSizes.inc120;
  fontSizes.headingM = fontSizes.inc100;
  fontSizes.headingS = fontSizes.inc80;
  fontSizes.headingXS = fontSizes.inc50;
  fontSizes.headingXXLResponsive = fontSizes.inc110;
  fontSizes.headingXLResponsive = fontSizes.inc90;
  fontSizes.headingLResponsive = fontSizes.inc70;
  fontSizes.headingMResponsive = fontSizes.inc60;
  fontSizes.headingSResponsive = fontSizes.inc50;
  fontSizes.headingXSResponsive = fontSizes.inc30;
  fontSizes.bodyL = fontSizes.inc40;
  fontSizes.bodyM = fontSizes.inc30;
  fontSizes.bodyS = fontSizes.inc20;
  fontSizes.bodyXS = fontSizes.inc10;
  fontSizes.bodyLResponsive = fontSizes.inc30;
  fontSizes.bodyMResponsive = fontSizes.inc20;
  fontSizes.bodySResponsive = fontSizes.inc10;
  fontSizes.bodyXSResponsive = fontSizes.inc10;
  fontSizes.monoL = fontSizes.inc20;
  fontSizes.monoM = fontSizes.inc10;
  fontSizes.monoS = fontSizes.inc00;
  fontSizes.monoLResponsive = fontSizes.inc20;
  fontSizes.monoMResponsive = fontSizes.inc10;
  fontSizes.monoSResponsive = fontSizes.inc00;
  spacing.base = 8;
  spacing.inc00 = 0;
  spacing.neg00 = 0;
  spacing.section00 = spacing.base;
  spacing.section10 = spacing.base * 2;
  spacing.section20 = spacing.base * 3;
  spacing.section30 = spacing.base * 6;
  spacing.section40 = spacing.base * 8;
  spacing.section50 = spacing.base * 12;
  spacing.section60 = spacing.base * 14;
  spacing.inc10 = spacing.base * 0.5;
  spacing.inc20 = spacing.base * 1;
  spacing.inc30 = spacing.base * 2;
  spacing.inc40 = spacing.base * 3;
  spacing.inc50 = spacing.base * 4;
  spacing.inc60 = spacing.base * 5;
  spacing.inc70 = spacing.base * 6;
  spacing.inc80 = spacing.base * 7;
  spacing.inc90 = spacing.base * 8;
  spacing.inc100 = spacing.base * 9;
  spacing.inc110 = spacing.base * 10;
  spacing.inc120 = spacing.base * 11;
  spacing.inc130 = spacing.base * 12;
  spacing.inc140 = spacing.base * 13;
  spacing.inc150 = spacing.base * 14;
  spacing.inc160 = spacing.base * 15;
  spacing.neg10 = spacing.base * -0.5;
  spacing.neg20 = spacing.base * -1;
  spacing.neg30 = spacing.base * -2;
  spacing.neg40 = spacing.base * -3;
  spacing.neg50 = spacing.base * -4;
  spacing.neg60 = spacing.base * -5;
  spacing.neg70 = spacing.base * -6;
  spacing.neg80 = spacing.base * -7;
  spacing.neg90 = spacing.base * -8;
  spacing.sectionGapZero = spacing.inc00;
  spacing.sectionGapXXSmall = spacing.section00;
  spacing.sectionGapXSmall = spacing.section10;
  spacing.sectionGapSmall = spacing.section20;
  spacing.sectionGapMedium = spacing.section30;
  spacing.sectionGapLarge = spacing.section40;
  spacing.sectionGapXLarge = spacing.section50;
  spacing.sectionGapXXLarge = spacing.section60;
  spacing.elementZero = spacing.inc00;
  spacing.elementXSmall = spacing.inc30;
  spacing.elementSmall = spacing.inc40;
  spacing.elementMedium = spacing.inc50;
  spacing.elementLarge = spacing.inc60;
  spacing.elementXLarge = spacing.inc70;
  spacing.colGapSmall = spacing.inc30;
  spacing.colGapMedium = spacing.inc40;
  spacing.outsideGutterSmall = spacing.inc40;
  spacing.outsideGutterMedium = spacing.inc50;
  spacing.outsideGutterLarge = spacing.inc70;
  spacing.cards = {
    paddingXXS: spacing.inc40,
    paddingXS: spacing.inc50,
    paddingS: spacing.inc60,
    paddingM: spacing.inc70,
    paddingL: spacing.inc80,
    paddingXL: spacing.inc110,
    paddingXXL: spacing.inc160
  };
  spacing.responsive = {
    verticalGap: {
      sectionZero: {
        small: 0,
        medium: 0,
        large: 0,
        xlarge: 0,
        xxlarge: 0
      },
      sectionXXSmall: {
        small: spacing.section00,
        medium: spacing.section00,
        large: spacing.section00,
        xlarge: spacing.section00,
        xxlarge: spacing.section00
      },
      sectionXSmall: {
        small: spacing.section10,
        medium: spacing.section10,
        large: spacing.section10,
        xlarge: spacing.section10,
        xxlarge: spacing.section10
      },
      sectionSmall: {
        small: spacing.section20,
        medium: spacing.section20,
        large: spacing.section20,
        xlarge: spacing.section20,
        xxlarge: spacing.section20
      },
      sectionMedium: {
        small: spacing.section30,
        medium: spacing.section30,
        large: spacing.section30,
        xlarge: spacing.section30,
        xxlarge: spacing.section30
      },
      sectionLarge: {
        small: spacing.sectionGapMedium,
        medium: spacing.sectionGapMedium,
        large: spacing.section40,
        xlarge: spacing.section40,
        xxlarge: spacing.section40
      },
      sectionXLarge: {
        small: spacing.inc80,
        medium: spacing.inc80,
        large: spacing.section50,
        xlarge: spacing.section50,
        xxlarge: spacing.section50
      },
      sectionXXLarge: {
        small: spacing.sectionGapLarge,
        medium: spacing.sectionGapLarge,
        large: spacing.section60,
        xlarge: spacing.section60,
        xxlarge: spacing.section60
      }
    },
    columnGap: {
      tight: {
        small: spacing.inc20,
        medium: spacing.inc30,
        large: spacing.inc40,
        xlarge: spacing.inc40,
        xxlarge: spacing.inc40
      },
      normal: {
        small: spacing.inc30,
        medium: spacing.inc50,
        large: spacing.inc70,
        xlarge: spacing.inc70,
        xxlarge: spacing.inc70
      },
      loose: {
        small: spacing.inc40,
        medium: spacing.inc60,
        large: spacing.inc90,
        xlarge: spacing.inc90,
        xxlarge: spacing.inc90
      },
      huge: {
        small: spacing.inc60,
        medium: spacing.inc80,
        large: spacing.inc130,
        xlarge: spacing.inc130,
        xxlarge: spacing.inc130
      }
    }
  };
  sizing.base = 8;
  sizing.maxWidthDesktop = 1416;
  sizing.inc00 = sizing.base * 0.5;
  sizing.inc10 = sizing.base * 2;
  sizing.inc20 = sizing.base * 3;
  sizing.inc30 = sizing.base * 4;
  sizing.inc40 = sizing.base * 5;
  sizing.inc50 = sizing.base * 6;
  sizing.inc60 = sizing.base * 7;
  sizing.inc70 = sizing.base * 8;
  sizing.inc80 = sizing.base * 9;
  sizing.inc90 = sizing.base * 10;
  sizing.inc100 = sizing.base * 11;
  sizing.systemIconLarge = sizing.inc30;
  sizing.systemIconMedium = sizing.inc20;
  sizing.systemIconSmall = sizing.inc10;
  sizing.codeSnippetSmall = sizing.base * 35;
  sizing.codeSnippetMedium = sizing.base * 60;
  sizing.codeSnippetLarge = sizing.base * 90;
  sizing.brandedIconSmall = sizing.inc50;
  sizing.brandedIconMedium = sizing.inc70;
  sizing.brandedIconLarge = sizing.inc90;
  sizing.breakpoint = {
    small: 460,
    medium: 768,
    large: 1024,
    xlarge: 1280,
    xxlarge: 1440
  };
  borderRadius.circle = 999;
  borderRadius.inc00 = 0;
  borderRadius.inc10 = 2;
  borderRadius.inc20 = 4;
  borderRadius.inc30 = 8;
  borderRadius.inc40 = 16;
  borderRadius.inc50 = 24;
  borderRadius.inc60 = 32;
  borderRadius.inc70 = 40;
  borderRadius.inc80 = 56;
  borderRadius.inc90 = 72;
  borderRadius.inc100 = 88;
  borderRadius.inc110 = 104;
  borderRadius.buttons = borderRadius.inc20;
  borderRadius.input = borderRadius.inc20;
  borderRadius.modal = borderRadius.inc20;
  borderRadius.tooltips = borderRadius.inc20;
  borderRadius.notification = borderRadius.inc20;
  borderRadius.card = borderRadius.inc70;
  borderRadius.cardResponsive = borderRadius.inc50;
  borderRadius.codePanel = borderRadius.inc60;
  borderRadius.buttonHover = borderRadius.inc70;
  borderRadius.scrollyStoryCard = borderRadius.inc50;
  borderRadius.scrollyStoryCardResponsive = borderRadius.inc40;
  boxShadow.level00 = {
    x: 0,
    y: 0,
    spread: 0,
    color: '#000000',
    blur: 0
  };
  boxShadow.level01 = {
    x: 0,
    y: 2,
    spread: 0,
    color: 'rgba(0,0,0,.1)',
    blur: 4
  };
  boxShadow.level02 = {
    x: 0,
    y: 3,
    spread: 0,
    color: 'rgba(0,0,0,.15)',
    blur: 9
  };
  boxShadow.level03 = {
    x: 0,
    y: 3,
    spread: 0,
    color: 'rgba(0,0,0,.15)',
    blur: 20
  };
  boxShadow.level04 = {
    x: 0,
    y: 6,
    spread: 0,
    color: 'rgba(0,0,0,.15)',
    blur: 30
  };
  boxShadow.buttonHover = {
    x: 0,
    y: 0,
    spread: 3,
    blur: 0,
    color: 'rgba(185, 234, 205, 1)'
  };
  boxShadow.buttonHoverInverse = {
    x: 0,
    y: 0,
    spread: 3,
    color: 'rgba(244, 255, 220, .4)',
    blur: 0
  };
  boxShadow.tagHover = {
    x: 0,
    y: 0,
    spread: 3,
    blur: 0,
    color: 'rgba(0, 108, 250, .4)'
  };
  boxShadow.tagHoverInverse = {
    x: 0,
    y: 0,
    spread: 3,
    color: 'rgba(166, 225, 236, .4)',
    blur: 0
  };
  borderWidth.inc00 = 0;
  borderWidth.inc10 = 1;
  borderWidth.inc20 = 2;
  borderWidth.inc30 = 3;
  borderWidth.ruleBreak = borderWidth.inc10;
  borderWidth.inputs = borderWidth.inc10;
  borderWidth.systemIconSmall = borderWidth.inc10;
  borderWidth.systemIconMedium = borderWidth.inc20;
  borderWidth.systemIconLarge = borderWidth.inc20;
  motion.inc00 = 100;
  motion.inc10 = 200;
  motion.inc20 = 250;
  motion.inc30 = 300;
  motion.inc40 = 350;
  motion.linkAnimation = motion.inc30;
  motion.mobileNavPanel = motion.inc30;
  motion.mobileNavItemExpand = motion.inc30;
  motion.tag = motion.inc00;
  motion.codeSnippetCopyFade = motion.inc30 * 10;
  motion.accordion = motion.inc40;
  opacity.inc00 = '0%';
  opacity.inc10 = '10%';
  opacity.inc20 = '20%';
  opacity.inc30 = '30%';
  opacity.inc40 = '40%';
  opacity.inc50 = '50%';
  opacity.inc60 = '60%';
  opacity.inc70 = '70%';
  opacity.inc80 = '80%';
  opacity.inc90 = '90%';
  opacity.inc100 = '100%';
  opacity.modalScrim = opacity.inc50;

  var transformToUnit = function transformToUnit(token, unit) {
    return Object.entries(token).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          value = _ref2[1];

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, typeof value === 'object' ? transformToUnit(value, unit) : "".concat(value).concat(unit)));
    }, {});
  };

  var transformToArrays = function transformToArrays(token) {
    return Object.entries(token).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          name = _ref4[0],
          value = _ref4[1];

      var values = Object.values(value);
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, values.length > 0 && typeof values[0] === 'number' ? Object.values(value) : typeof value === 'object' ? transformToArrays(value) : []));
    }, {});
  }; // format box shadow tokens to box shadow css shorthand


  var formatToBoxShadow = function formatToBoxShadow(boxShadow) {
    return Object.entries(boxShadow).reduce(function (acc, _ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          name = _ref6[0],
          _ref6$ = _ref6[1],
          x = _ref6$.x,
          y = _ref6$.y,
          spread = _ref6$.spread,
          color = _ref6$.color,
          blur = _ref6$.blur;

      /* offset-x | offset-y | blur-radius | spread-radius | color */
      acc[name] = "".concat(x, "px ").concat(y, "px ").concat(blur, "px ").concat(spread, "px ").concat(color);
      return acc;
    }, {});
  };

  var convertToPx = function convertToPx(token) {
    return transformToUnit(token, 'px');
  };

  var convertToMs = function convertToMs(token) {
    return transformToUnit(token, 'ms');
  };

  var shadows = formatToBoxShadow(boxShadow);
  var borders = convertToPx(borderWidth);
  var themeLegacy = {
    colors: colors,
    shadows: shadows,
    borders: borders,
    fonts: fontFamilies,
    fontWeights: fontWeights,
    sizes: convertToPx(sizing),
    radii: convertToPx(borderRadius),
    lineHeights: convertToPx(lineHeights),
    fontSizes: convertToPx(fontSizes),
    space: convertToPx(spacing),
    responsive: transformToArrays(spacing.responsive),
    borderWidths: borders,
    breakpoints: Object.values(convertToPx(sizing.breakpoint)),
    motion: convertToMs(motion),
    opacity: opacity,
    config: {
      useRootStyles: false
    }
  };
  return themeLegacy;
});